import React, { FC } from 'react';
import { Alert } from 'antd';
import {
	COMPLIANCE_EVALUATION_LOADING_MESSAGES,
	ComplianceAiLoadingSkeleton,
} from './ComplianceAiLoadingSkeleton';
import { ComplianceDocumentSplitView } from './ComplianceDocumentSplitView';
import { ComplianceEvaluationResults } from './ComplianceEvaluationResults';
import { ChecklistEvaluation, ChecklistExtractionItem } from '../../types/ComplianceChecklistTypes';

interface ComplianceDocumentCheckPanelProps {
	// The bytes being checked, shown on the left. Null until a picked document
	// finishes downloading; a fresh upload has it immediately.
	documentFile: File;
	fileName: string;
	evaluating: boolean;
	evaluation: ChecklistEvaluation;
	// Items from the request's stored checklistExtraction.
	checklistItems: ChecklistExtractionItem[];
	// Why the check did not happen or did not finish, when it did not.
	skipReason?: string;
}

// The document on the left, the findings on the right, so a supplier can read a
// failure and look at the field it is about without switching views.
export const ComplianceDocumentCheckPanel: FC<ComplianceDocumentCheckPanelProps> = ({
	documentFile,
	fileName,
	evaluating,
	evaluation,
	checklistItems,
	skipReason,
}): React.ReactElement => {
	const renderFindings = () => {
		if (evaluating) {
			return <ComplianceAiLoadingSkeleton messages={COMPLIANCE_EVALUATION_LOADING_MESSAGES} />;
		}
		if (evaluation) {
			return (
				<ComplianceEvaluationResults
					evaluation={evaluation}
					checklistItems={checklistItems}
					fileName={fileName}
				/>
			);
		}
		return (
			<Alert
				type="warning"
				showIcon={true}
				message="We could not check this document automatically"
				description={`${skipReason} You can still link it — your client will review it as usual.`}
			/>
		);
	};

	return (
		<ComplianceDocumentSplitView documentFile={documentFile} fileName={fileName}>
			{renderFindings()}
		</ComplianceDocumentSplitView>
	);
};
